/**
 * 站内消息/通知 - 操作指引、消息通知
 */
import { apiGet, apiPost, apiPut } from '@/utils/request';

/** 消息项（兼容 content 嵌套与扁平 title/content） */
export interface AppMessageItem {
  id: number;
  type?: number;
  status: number;
  title?: string;
  content?: string | { title?: string; content?: string };
  extra?: Record<string, unknown>;
  created_at?: string;
  updated_at?: string;
}

/** 通知列表响应 - GET /api/notifications */
export interface NotificationListResponse {
  list: AppMessageItem[];
  total: number;
  page: number;
  per_page: number;
  unread_counts?: { system?: number; push?: number; total?: number };
}

/** 获取通知列表（分页），返回各类型未读数量。type 必填，status 可选 */
export function queryNotificationList(params: {
  type: number;
  status?: number;
  page?: number;
  per_page?: number;
}): Promise<NotificationListResponse> {
  return apiGet<NotificationListResponse>('/notifications', params as Record<string, unknown>);
}

/** 消息列表响应（旧接口兼容） */
export interface AppMessageResponse {
  items: AppMessageItem[];
  system_no_read_total: number;
  system_total: number;
  user_no_read_total: number;
  user_total: number;
}

/** 获取站内消息列表（旧接口，保留兼容） */
export function queryAppMessageList(params: {
  page?: number;
  pageSize?: number;
  type?: number;
}): Promise<AppMessageResponse> {
  return apiPost('/appMsg/getAppMessage', params).then((d: unknown) => {
    const raw = d as { data?: AppMessageResponse } & AppMessageResponse;
    const data = raw?.data ?? raw;
    return {
      items: data?.items ?? [],
      system_no_read_total: data?.system_no_read_total ?? 0,
      system_total: data?.system_total ?? 0,
      user_no_read_total: data?.user_no_read_total ?? 0,
      user_total: data?.user_total ?? 0,
    };
  });
}

/** 标记通知为已读/未读，支持单条(id)或批量(ids)，二选一 */
export function queryUpdateNotificationStatus(params: {
  status: number;
  id?: number;
  ids?: number[];
}): Promise<unknown> {
  return apiPut('/notifications', params);
}

/** 修改消息状态（旧接口，保留兼容） */
export function queryUpdateMessageStatus(params: { status: number; id: number }): Promise<unknown> {
  return apiPost('/appMsg/changeStatus', params);
}
